module.exports = __webpack_public_path__ + "static/ICONMESSANGES-06-7d5fc494b6579efa1037041e3bbd6f7c.png";